import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { SvgIconOwnProps } from '@mui/material/SvgIcon/SvgIcon';

import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModel } from '../../model/Confirmation.model';

type Props = {
  confirmation: ConfirmationModel | null;
  closeDialog: () => void;
}
export const ConfirmationDialog = ({ confirmation, closeDialog }: Props): JSX.Element => {
  const { t } = useTranslation();

  if (!confirmation) {
    return <></>;
  }

  const onConfirm = (): void => {
    if (confirmation.onConfirm) {
      confirmation.onConfirm();
    }

    closeDialog();
  };

  const onReject = (): void => {
    if (confirmation.onReject) {
      confirmation.onReject();
    }

    closeDialog();
  };

  const resolveIcon = (): JSX.Element | null => {
    const props: SvgIconOwnProps = { fontSize: 'large' };

    switch (confirmation.icon) {
      case 'warning':
        return <WarningAmberOutlinedIcon {...props} />;
      default:
        return null;
    }
  };

  const icon = resolveIcon();

  const rejectLabel = confirmation.rejectButtonLabel || t('actions.cancel', { ns: 'common' });
  const confirmLabel = confirmation.confirmButtonLabel || t('actions.confirm', { ns: 'common' });

  return <Dialog open={!!confirmation}>
    <DialogTitle sx={{
      borderBottom: '1px #dfe7ef solid',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Box sx={{ fontWeight: 600, fontSize: 18 }}>{confirmation.title}</Box>
      {confirmation.closeIcon &&
        <CloseOutlinedIcon fontSize="small" sx={{ cursor: 'pointer' }} onClick={closeDialog} />}
    </DialogTitle>
    <DialogContent sx={{ display: 'flex' }}>
      {icon && <Box sx={{ mt: 3, mr: 3 }}>{icon}</Box>}
      <Box>
        <Box sx={{ mt: 3, fontSize: 14 }}>{confirmation.message}</Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 4 }}>
          <Button variant="outlined" onClick={onReject}>{rejectLabel}</Button>
          <Button variant="contained" onClick={onConfirm}>{confirmLabel}</Button>
        </Box>
      </Box>
    </DialogContent>
  </Dialog>;
};
